module.exports = __webpack_public_path__ + "img/gallery_3.2b295dcd.jpg";